export default __webpack_public_path__ + "images/4Z.26dd514.png";